export default {
  amountDue: "Montant dû",
  amountPaid: "Montant payé",
  amountPaying: "Montant à payer",
  billTo: "Facturer à",
  contactForPayment:
    "Veuillez contacter {{organization}} pour les modalités de paiement.",
  howToPay: "Comment payer",
  currency: "Devise",
  discount: "Remise",
  due: "Échéance",
  editCustomAmount: "Modifier le montant personnalisé",
  fees: "Frais",
  from: "De",
  invalidPaymentLink: "Lien de paiement invalide",
  invoiceFor: "Facture pour",
  invoiceTotal: "Total de la facture",
  issued: "Émise le",
  partiallyPaid: "partiellement payée",
  payLead: "Payez en toute sécurité par carte.",
  payThisInvoice: "Payer cette facture",
  paymentsSecure: "Les paiements sont sécurisés et chiffrés",
  processingFeeTooltip:
    "Frais de traitement de carte facturés par le réseau de paiement.",
  processingPayment: "Traitement du paiement…",
  securePayment: "Paiement sécurisé",
  setAmount: "Définir le montant",
  subtotal: "Sous-total",
  payCustomAmount: "Payer un montant personnalisé",
  payFullAmount: "Payer le montant total",
  paymentAmount: "Montant du paiement",
  pay: "Payer",
  tax: "Taxe",
  total: "Total",
  totalAmountPaying: "Montant total à régler",
  totalCharge: "Montant total à payer",
  unpaid: "impayée",
};
